import { render } from "./PagesEditContacts.vue?vue&type=template&id=c1637474&scoped=true"
import script from "./PagesEditContacts.vue?vue&type=script&lang=js"
export * from "./PagesEditContacts.vue?vue&type=script&lang=js"

import "./PagesEditContacts.vue?vue&type=style&index=0&id=c1637474&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1637474"]])

export default __exports__